import { useEffect, useRef } from 'react';
import {
  toInstrumentTick,
  type InstrumentTick,
  type WsInstrumentTick,
} from '@sunflower-games/predictions-realtime-contracts';
import { useRealtimeManager } from '../realtime-manager-ctx';

/**
 * Subscribe to the underlying-instrument firehose. The hook filters by
 * `instrumentCode` client-side — the Plaee channel is global, not per-asset.
 */
export function useInstrumentRealtime(
  instrumentCode: string | null | undefined,
  onTick: (tick: InstrumentTick) => void,
): void {
  const manager = useRealtimeManager();
  const handlerRef = useRef(onTick);
  useEffect(() => {
    handlerRef.current = onTick;
  });

  useEffect(() => {
    if (import.meta.env.DEV) {
      console.info('[useInstrumentRealtime] effect ran, instrumentCode =', instrumentCode);
    }
    if (!instrumentCode) return;
    return manager.subscribeInstruments((raw) => {
      const msg = raw as WsInstrumentTick;
      if (msg.instrumentCode !== instrumentCode) return;
      handlerRef.current(toInstrumentTick(msg));
    });
  }, [manager, instrumentCode]);
}
